import { StarOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'

export function DefaultTransporterRenderer({ value }: { value: boolean }) {
  if (value) {
    return (
      <Tooltip title='This carrier is a default transporter for the system'>
        <StarOutlined style={{ color: 'var(--theme-color-1)', fontSize: '18px' }} />
      </Tooltip>
    )
  }
  return null
}
